import React, { Component } from 'react';
import classes from './UploadResourceVideo.module.css';

import Button from '../../../UI/Button/Button';
import { IsObjectEmpty, IsStringEmpty } from '../../../../utilities/CommonMethods';
import ResourceAPIController from '../../../../webServices/ResourceAPIController';
import CloseIcon from '../../../../assets/icons/icon-close-black.svg'
import Input from '../../../UI/Input/Input';
import { GetObjectClone } from '../../../../utilities/CommonMethods';
import FormFields from '../../../Forms/FormFields';
import QuizOption from '../../../UI/QuizOption/QuizOption';
import ProgressBar from '../../../UI/ProgressBar/ProgressBar';
import S3FileUpload from '../../../../webServices/S3FileUpload';
import ShowMiniLoader from '../../../../hoc/ShowMiniLoader/ShowMiniLoader';

// import CloseIconBlack from '../../../../assets/icons/icon-close-black.png';
import ConfirmationDialog from '../../../../components/Popups/ConfirmationDialog/ConfirmationDialog';

class UploadResourceVideo extends Component {
    state = {
        showDeleteOption: false,
        showContentLoader: false,
        showLoader: false,
        showSuccessMessage: false,
        messageList: [],
        file: null,
        filename: '',
        showFileOptions: false,
        uploadResourcesFormData: GetObjectClone(FormFields.uploadResourcesTPStreams),
        uploadResourcesFormIsValid: false,
        gradingGuidesList: [
            { id: '', value: '', maxScore: '', errorMessage: '', scoreErrorMessage: '', valid: true }
        ],
        showError: false,
        errorMessage: '',
        fileExtension: '',
        disabledButton: false,
        vimeoID: '',
        uploadOptions: [
            { optionData: 'Upload Video', type: "text", selected: false, value: 'videoFile' },
            { optionData: 'TPStreams', type: "text", selected: true, value: 'tpStreams' },
            { optionData: 'Vimeo Id', type: "text", selected: false, value: 'vimeoId' },
        ],
        selectedFileType: '',
        activeUploadType: 1,
        progress: 0,
        selectedFileName: '',
        showMiniLoader: false,
        showConfirmationPopup: false,
    }

    onFileSelected = (event) => {
        this.setState({ fileErrorMessage: '' });
        if ((event.target !== undefined && event.target.files.length > 0) || event.length > 0) {
            const file = event.target !== undefined ? event.target.files[0] : event[0];
            const fileName = file.name;
            const fileExtension = file.name.split('.').pop();
            const fileSize = file.size;

            const allowedFileTypes = ['mp4', 'avi'];
            if (allowedFileTypes.indexOf(fileExtension) < 0) {
                // this.props.onFailureDialogShow('File type not supported. Please upload a valid mp4 or avi file.', 'OKAY')
                this.setState({ fileErrorMessage: 'File type not supported. Please upload a valid mp4 or avi file.' });
                return;
            } else if (event.length > 1) {
                // this.props.onFailureDialogShow('Please select single file.', 'OKAY')
                this.setState({ fileErrorMessage: 'Please select single file.' });
                return;
            }
            else if (fileSize <= 2147483648) {
                this.setState({ showLoader: false, file: file, selectedFileType: fileExtension, disabledButton: false, selectedFileName: fileName });
            } else if (fileSize >= 2147483648) {
                // this.props.onFailureDialogShow('File size should be less than 2 GB.', 'OKAY')
                this.setState({ fileErrorMessage: 'Select a file with size less than 2 GB.' });
            }
        }
        else {
            alert("File not selected!")
        }
    }

    onSaveResourcesClick = () => {



    }


    checkValidity = (formElement) => {
        let isValid = true;

        if (!IsObjectEmpty(formElement.validation)) {
            let value = formElement.value;
            const rules = formElement.validation;
            if (!IsObjectEmpty(rules.required) && rules.required.value) {
                if (typeof (value) === 'string' && value !== ' ' && value !== '' && value.trim().length > 0) {
                    isValid = true && isValid;
                } else if ((typeof (value) === 'number' && parseInt(value, 10)) || value === 0) {
                    isValid = true && isValid;
                } else {
                    isValid = false;
                }
                formElement.errorMessage = isValid ? '' : rules.required.errorMessage;
                formElement.valid = isValid;
            }

            if (!IsObjectEmpty(rules.isDropdown) && rules.isDropdown.value) {
                isValid = (value >= 0) && isValid;
                formElement.errorMessage = isValid ? '' : rules.isDropdown.errorMessage;
                formElement.valid = isValid;
            }
        }
        return (formElement);
    }

    inputChangedHandlerText = (event, inputIdentifier) => {
        const updatedForm = this.state.uploadResourcesFormData;
        let updatedFormElement = updatedForm[inputIdentifier];

        updatedFormElement.value = event.target.value;

        updatedFormElement.touched = true;
        updatedFormElement = this.checkValidity(updatedFormElement, updatedForm);
        updatedForm[inputIdentifier] = updatedFormElement;

        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            if (!IsObjectEmpty(updatedForm[inputIdentifier].validation.required) && updatedForm[inputIdentifier].validation.required.value) {
                formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
            }
        }
        this.setState({ uploadResourcesFormData: updatedForm, uploadResourcesFormIsValid: formIsValid });
    }
    inputField = (key) => {
        return <Input
            inputIdentifier={key}
            elementType={this.state.uploadResourcesFormData[key].elementType}
            elementConfig={this.state.uploadResourcesFormData[key].elementConfig}
            label={this.state.uploadResourcesFormData[key].label}
            value={this.state.uploadResourcesFormData[key].value}
            changed={(event) => this.inputChangedHandlerText(event, key)}
            touched={this.state.uploadResourcesFormData[key].touched}
            required={!IsObjectEmpty(this.state.uploadResourcesFormData[key].validation) ? (!IsObjectEmpty(this.state.uploadResourcesFormData[key].validation.required) ? this.state.uploadResourcesFormData[key].validation.required.value : false) : false}
            showError={(!this.state.uploadResourcesFormIsValid && !this.state.uploadResourcesFormData[key].valid) ? true : false}
            error={this.state.uploadResourcesFormData[key].errorMessage} />
    }

    onSaveVideoClick = () => {
        // Function for Vimeo Video Upload
        const updatedForm = this.state.uploadResourcesFormData;
        for (let item in updatedForm) {
            updatedForm[item] = this.checkValidity(updatedForm[item], updatedForm);
        }

        if (this.state.activeUploadType === 2) {
            // ---->>> Upload Video for Vimeo <<< ----
            let formIsValid = true;
            formIsValid = updatedForm['fileTitle'].valid && formIsValid;
            formIsValid = updatedForm['vimeoID'].valid && formIsValid;

            if (formIsValid) {
                this.setState({
                    fileTitle: updatedForm.fileTitle.value,
                    vimeoID: updatedForm.vimeoID.value,
                    disabledButton: true,
                    uploadResourcesFormData: updatedForm,
                    uploadResourcesFormIsValid: formIsValid,
                    fileErrorMessage: '',
                    showMiniLoader: true
                })

                const data = {
                    video_id: updatedForm['vimeoID'].value, // 252404065
                    name: updatedForm['fileTitle'].value,
                    is_session_recording: false
                }
                ResourceAPIController.createVimeoVideo(this.props.topicId, data)
                    .then((response) => {
                        this.props.onSuccessDialogShow(response.result.message, 'OKAY');
                        this.props.closeModal();
                        this.props.onUploadSuccessful();
                    })
                    .catch((err) => {
                        console.log('Create VIMEO Video Failed => ', err);
                        // this.props.onFailureDialogShow('Error while creating video. Please try again.', 'OKAY')
                        this.setState({ fileErrorMessage: 'Error while creating video. Please try again.' });
                    });

            } else {
                this.setState({ uploadResourcesFormData: updatedForm, uploadResourcesFormIsValid: formIsValid, fileErrorMessage: '' });
            }
        } else {
            // ---->>> Upload Video for TPStreams <<< ----
            let formIsValid = true;
            formIsValid = updatedForm['fileTitle'].valid && formIsValid;
            formIsValid = updatedForm['assetId'].valid && formIsValid;
            formIsValid = updatedForm['accessToken'].valid && formIsValid;

            if (formIsValid) {
                this.setState({
                    fileTitle: updatedForm.fileTitle.value,
                    assetId: updatedForm.assetId.value,
                    accessToken: updatedForm.accessToken.value,
                    disabledButton: true,
                    uploadResourcesFormData: updatedForm,
                    uploadResourcesFormIsValid: formIsValid,
                    fileErrorMessage: '',
                    showMiniLoader: true
                })

                const data = {
                    asset_id: updatedForm['assetId'].value,
                    access_token: updatedForm['accessToken'].value,
                    name: updatedForm['fileTitle'].value,
                    is_session_recording: false
                }

                // console.log("Final Data for TP Stream Video Upload => ", data)

                ResourceAPIController.createVimeoVideo(this.props.topicId, data)
                    .then((response) => {
                        this.props.onSuccessDialogShow(response.result.message, 'OKAY');
                        this.props.closeModal();
                        this.props.onUploadSuccessful();
                    })
                    .catch((err) => {
                        console.log('Create VIMEO Video Failed => ', err);
                        // this.props.onFailureDialogShow('Error while creating video. Please try again.', 'OKAY')
                        this.setState({ fileErrorMessage: 'Error while creating video. Please try again.' });
                    });

            } else {
                this.setState({ uploadResourcesFormData: updatedForm, uploadResourcesFormIsValid: formIsValid, fileErrorMessage: '' });
            }
        }
    }

    onDeleteVideoFileClicked = (videoData) => {
        this.setState({ showConfirmationPopup: true, videoData });
    }

    onClosedPopup = () => {
        this.setState({ showConfirmationPopup: false });
    }

    onDeleteResourceButtonClick = () => {

        this.setState({ showMiniLoader: true, loaderMessage: "Please wait, the resource file is being deleted." });

        ResourceAPIController.deleteResource(this.state.videoData.id, 'video')
            .then((response) => {
                // console.log("Response after deleting => ", response.result)
                this.props.getTopicDetails(this.props.topicId);
                this.setState({ showMiniLoader: false, loaderMessage: "" });
                this.props.onSuccessDialogShow("Resource file deleted successfully.", 'OKAY');
                this.props.closeModal();

            })
            .catch((err) => {
                console.log("Error after deleting =>>> ", err)
                this.props.onFailureDialogShow("Something went wrong. Please refresh the page and try again.", "OKAY")
                // alert("Something went wrong. Please refresh the page and try again.")
                this.props.closeModal();
                this.setState({ showMiniLoader: false, loaderMessage: "" });
            });

        this.setState({ showConfirmationPopup: false });


    }

    onAddNewVideoClick = () => {
        this.setState({ showFileOptions: true });
    }

    onOptionClicked = (optionPos) => {
        if (optionPos === 0)
            return;
        let updatedOptions = [...this.state.uploadOptions];
        for (var i = 0; i < updatedOptions.length; i++) {
            if (i === optionPos) {
                updatedOptions[optionPos].selected = true;
                this.setState({ fileErrorMessage: '' })
            } else {
                updatedOptions[i].selected = false;
            }
        }

        let updatedForm = optionPos === 2 ? GetObjectClone(FormFields.uploadResources) : GetObjectClone(FormFields.uploadResourcesTPStreams);

        for (let inputIdentifier in updatedForm) {
            if (!IsObjectEmpty(updatedForm[inputIdentifier].validation.required) && updatedForm[inputIdentifier].validation.required.value) {
                updatedForm[inputIdentifier].valid = true;
                updatedForm[inputIdentifier].value = '';
            }
        }
        this.setState({ uploadResourcesFormData: updatedForm, activeUploadType: optionPos, uploadOptions: updatedOptions });
    }

    cancelUploadClick = () => {
        this.setState({ selectedFileName: '', file: '' })
    }

    updateUploadProgress = (progress) => {
        this.setState({ progress: progress });
    }

    onUploadVideoClick = () => {
        // Function for Normal Video Upload
        const updatedForm = this.state.uploadResourcesFormData;
        for (let item in updatedForm) {
            updatedForm[item] = this.checkValidity(updatedForm[item], updatedForm);
        }

        let formIsValid = true;
        formIsValid = updatedForm['fileTitle'].valid && formIsValid;

        if (formIsValid && !IsStringEmpty(this.state.selectedFileName)) {

            const fileName = updatedForm.fileTitle.value;
            this.setState({ fileTitle: fileName, disabledButton: true, uploadResourcesFormData: updatedForm, uploadResourcesFormIsValid: formIsValid, fileErrorMessage: '' })

            ResourceAPIController.getVideoUploadSignature(fileName, this.state.selectedFileType)
                .then(response => {
                    S3FileUpload.uploadFile(this.state.file, response.result.data, this.updateUploadProgress)
                        .then(res => {
                            const videoS3URL = res.result.headers.location;
                            // this.setState({ videoS3FileUrl: videoS3URL });
                            this.sendCreateVideoCall(videoS3URL, fileName);
                        })
                        .catch(err => {
                            console.log("S3FileUpload Function Error => ", err);

                            // this.props.onFailureDialogShow('Error while uploading file on server. Please try again.', 'OKAY')
                            this.setState({ fileErrorMessage: 'Error while uploading file on server. Please refresh the page and try again.' });
                        });
                })
                .catch(err => {
                    // alert('Error for getVideoUploadSignature');
                    console.log('Got error for getVideoUploadSignature => ', err);
                    this.setState({ fileErrorMessage: 'Error while uploading file on server. Please refresh the page and try again.' });
                });

        } else {
            this.setState({ uploadResourcesFormData: updatedForm, uploadResourcesFormIsValid: formIsValid, fileErrorMessage: '' });
        }
    }

    sendCreateVideoCall = (videoS3URL, fileName) => {
        this.setState({ showMiniLoader: true });
        const data = {
            video_s3_url: videoS3URL,
            name: fileName,
            is_session_recording: false
        }
        ResourceAPIController.createVideo(this.props.topicId, data)
            .then((response) => {
                this.props.onSuccessDialogShow(response.result.message, 'OKAY');
                this.props.closeModal();
                this.props.onUploadSuccessful();
            })
            .catch((err) => {
                console.log('Create Video Failed => ', err);
                // this.props.onFailureDialogShow('Error while creating video. Please try again.', 'OKAY')
                this.setState({ fileErrorMessage: 'Error while creating video. Please refresh the page and try again.' });
            });
    }

    render() {

        const renderUploadOptions = this.state.uploadOptions.map((option, index) => {
            return <QuizOption
                key={index}
                pos={index}
                selected={option.selected}
                questionId={'uploadType'}
                optionType={option.type}
                questionType={'single'}
                optionData={option.optionData}
                onOptionClicked={this.onOptionClicked}
            />
        });

        return (
            <>
                <ConfirmationDialog
                    show={this.state.showConfirmationPopup}
                    message={"Are you sure you want to delete this video file?"}
                    secondaryButtonLabel="CANCEL"
                    secondaryButtonClick={this.onClosedPopup}
                    primaryButtonLabel="DELETE"
                    primaryButtonClicked={this.onDeleteResourceButtonClick} />

                <div>
                    {
                        this.state.showFileOptions === false
                            ? this.state.showMiniLoader === false
                                ? <>
                                    <p className={classes.SubHeading}>Pre-watch Videos</p>
                                    <ul className={classes.ResourceFilesList}>
                                        {
                                            !IsObjectEmpty(this.props.resourceFiles) && !IsObjectEmpty(this.props.resourceFiles.preWatchVideos)
                                                ? this.props.resourceFiles.preWatchVideos.map((video, index) => {
                                                    return <li key={index} className={classes.ResourceFileListItem}>{(index + 1) + '. ' + video.videoTitle}
                                                        {/* &nbsp;
                                                        <img
                                                            className={classes.SessionRecordingCloseButton}
                                                            onClick={() => this.onDeleteVideoFileClicked(video)}
                                                            height={10}
                                                            width={10}
                                                            src={CloseIconBlack} /> */}
                                                    </li>
                                                }) : <li className={classes.ResourceFileListItem}>No pre-watch videos available!</li>
                                        }
                                    </ul>
                                    <div className={classes.AlignRight}>
                                        <Button label="ADD NEW VIDEO" margin="1.5em 0" styleclass="GoToCourseButton" clicked={() => this.onAddNewVideoClick()} />
                                    </div>
                                </>
                                : <div className={classes.LoaderContainer}>
                                    {this.state.loaderMessage}<br /><br />
                                    <ShowMiniLoader isLoading={true} transparentBg={true} />
                                </div>
                            : <div className={classes.Container}>
                                <div className={classes.AddNewFileContainer}>
                                    <p className={classes.SubHeading}>Add New Pre-Watch Video</p>
                                    <div className={classes.OptionsContainer}>
                                        {renderUploadOptions}
                                    </div>
                                    {
                                        this.state.activeUploadType === 0
                                            ? IsStringEmpty(this.state.selectedFileName)
                                                ? <>
                                                    <p className={classes.SelectFileHeading}>Select File</p>
                                                    <div className={classes.SelectFileInput}>
                                                        <input type="file" onChange={this.onFileSelected} className={classes.FileInput} />
                                                    </div>

                                                    {!IsStringEmpty(this.state.fileErrorMessage)
                                                        ? <p className={classes.ErrorMessage}>{this.state.fileErrorMessage}</p>
                                                        : null}
                                                </>
                                                : <>
                                                    <div className={classes.UploadProgressDiv}>
                                                        <ProgressBar
                                                            styleclass="Rounded"
                                                            showProgressText={false}
                                                            progress={this.state.progress} />
                                                        <span className={classes.ProgressCount} title={this.state.selectedFileName}> {'Uploading: ' + this.state.selectedFileName}
                                                        </span>
                                                        {
                                                            Math.ceil(this.state.progress) === 0
                                                                ? <img src={CloseIcon} alt="Cancel Upload Icon" title="Cancel Upload" className={classes.CancelUploadIcon} onClick={this.cancelUploadClick} />
                                                                : <span className={classes.ProgressCountSpan}>
                                                                    {' (' + this.state.progress} %)
                                                                </span>
                                                        }
                                                    </div>
                                                    <div className={classes.FileDetailsDiv}>
                                                        <div className={classes.FileTitle}>
                                                            {this.inputField('fileTitle')}
                                                        </div>
                                                    </div>

                                                    {!IsStringEmpty(this.state.fileErrorMessage)
                                                        ? <p className={classes.ErrorMessage}>{this.state.fileErrorMessage}</p>
                                                        : null}
                                                    {
                                                        this.state.showMiniLoader
                                                            ? <div className={classes.LoaderContainer}>
                                                                Please wait, the video is being saved <br /><br />
                                                                <ShowMiniLoader isLoading={true} transparentBg={true} />
                                                            </div>
                                                            : null
                                                    }

                                                    <div className={classes.ButtonContainer}>
                                                        <Button label="UPLOAD"
                                                            styleclass={this.state.disabledButton ? '' : "GoToCourseButton"}
                                                            margin="0px"
                                                            disabled={this.state.disabledButton}
                                                            clicked={this.state.disabledButton ? null : () => this.onUploadVideoClick(false)} />
                                                    </div>
                                                </>
                                            : this.state.activeUploadType === 2
                                                ? <>
                                                    <div className={classes.FileDetailsDiv}>
                                                        <div className={classes.FileTitle}>
                                                            {this.inputField('fileTitle')}
                                                        </div>
                                                        <div className={classes.FileTitle}>
                                                            {this.inputField('vimeoID')}
                                                        </div>
                                                    </div>

                                                    {!IsStringEmpty(this.state.fileErrorMessage)
                                                        ? <p className={classes.ErrorMessage}>{this.state.fileErrorMessage}</p>
                                                        : null}

                                                    {
                                                        this.state.showMiniLoader
                                                            ? <div className={classes.LoaderContainer}>
                                                                Please wait, the video is being saved <br /><br />
                                                                <ShowMiniLoader isLoading={true} transparentBg={true} />
                                                            </div>
                                                            : null
                                                    }

                                                    <div className={classes.ButtonContainer}>
                                                        <Button label="SAVE"
                                                            styleclass="GoToCourseButton"
                                                            margin="0px"
                                                            clicked={() => this.onSaveVideoClick(true)} />
                                                    </div>
                                                </>
                                                : <>
                                                    <div className={classes.FileTitle}>
                                                        {this.inputField('fileTitle')}
                                                    </div>
                                                    <div className={classes.FileDetailsDiv}>
                                                        <div className={classes.FileTitle}>
                                                            {this.inputField('assetId')}
                                                        </div>
                                                        <div className={classes.FileTitle}>
                                                            {this.inputField('accessToken')}
                                                        </div>
                                                    </div>

                                                    {!IsStringEmpty(this.state.fileErrorMessage)
                                                        ? <p className={classes.ErrorMessage}>{this.state.fileErrorMessage}</p>
                                                        : null}

                                                    {
                                                        this.state.showMiniLoader
                                                            ? <div className={classes.LoaderContainer}>
                                                                Please wait, the video is being saved <br /><br />
                                                                <ShowMiniLoader isLoading={true} transparentBg={true} />
                                                            </div>
                                                            : null
                                                    }

                                                    <div className={classes.ButtonContainer}>
                                                        <Button label="SAVE"
                                                            styleclass="GoToCourseButton"
                                                            margin="0px"
                                                            clicked={() => this.onSaveVideoClick(true)} />
                                                    </div>
                                                </>
                                    }
                                </div>
                            </div>
                    }
                </div>
            </>
        );
    }
}

export default UploadResourceVideo;